import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { Card, PublicShell } from "@/components/PublicShell";
import { LinkHero } from "@/components/LinkHero";
import { inputCls, itDate } from "@/components/kit";
import { API, api, errMsg } from "@/lib/api";

export default function Foto() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [autore, setAutore] = useState(localStorage.getItem("bm-foto-nome") || "");
  const [consenso, setConsenso] = useState(false);
  const [prog, setProg] = useState("");
  const load = useCallback(() => api.get(`/public/foto/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))), [token]);
  useEffect(() => {
    load();
  }, [load]);
  const upload = async (files) => {
    localStorage.setItem("bm-foto-nome", autore);
    let ok = 0;
    for (const [i, f] of [...files].entries()) {
      setProg(`Carico ${i + 1} di ${files.length}…`);
      const fd = new FormData();
      fd.append("file", f);
      fd.append("autore", autore);
      fd.append("consenso", consenso ? "true" : "false");
      try {
        await api.post(`/public/foto/${token}`, fd);
        ok += 1;
      } catch (e) {
        toast.error(`${f.name}: ${errMsg(e)}`);
      }
    }
    setProg("");
    if (ok) toast.success(`${ok} foto caricate, grazie!`);
    load();
  };
  return (
    <PublicShell testId="photo-page">
      {!err && <div className="mb-4"><LinkHero kind="foto" token={token} /></div>}
      {err && <Card><p data-testid="photo-error">{err}</p></Card>}
      {d && (
        <>
          <Card>
            <div className="text-xs uppercase tracking-[0.3em] text-[#34B3B0]">Album della festa</div>
            <h1 className="font-serif-it text-4xl text-[#0D2B3A]" data-testid="photo-title">{d.cliente_nome}</h1>
            <p className="text-sm text-[#47606B]">{d.evento_tipo} • {itDate(d.evento_data)} • {d.sede}</p>
            <input className={inputCls} value={autore} onChange={(e) => setAutore(e.target.value)} placeholder="Il tuo nome (facoltativo)" data-testid="photo-autore" />
            <label className="flex items-start gap-2 text-xs text-[#47606B]"><input type="checkbox" className="mt-0.5" checked={consenso} onChange={(e) => setConsenso(e.target.checked)} data-testid="photo-consenso" /> Acconsento che la struttura usi queste foto sui propri canali (social, brochure). Facoltativo.</label>
            <label className={`flex items-center justify-center gap-2 rounded-full bg-[#0B6E8F] text-white px-5 py-3 text-sm cursor-pointer ${prog ? "opacity-60" : ""}`} data-testid="photo-upload">
              {prog ? <Loader2 size={16} className="animate-spin" /> : <Camera size={16} />} {prog || "Carica le tue foto"}
              <input type="file" accept="image/*" multiple className="hidden" disabled={!!prog} onChange={(e) => e.target.files.length && upload(e.target.files)} />
            </label>
            <p className="text-[11px] text-[#7B929C]">Le foto sono visibili a tutti gli invitati che hanno questo link.</p>
          </Card>
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 mt-4" data-testid="photo-grid">
            {d.photos.map((p) => <a key={p.id} href={`${API}/public/foto/${token}/${p.id}`} target="_blank" rel="noreferrer"><img src={`${API}/public/foto/${token}/${p.id}?thumb=1`} alt={p.autore} loading="lazy" className="aspect-square object-cover rounded-lg w-full" /></a>)}
          </div>
        </>
      )}
    </PublicShell>
  );
}
